export const AS_SET_LOADING = "AS_SET_LOADING";
export const AS_SET_ERROR = "AS_SET_ERROR";

export const AS_SET_SKILLS = "AS_SET_SKILLS";
export const AS_SET_CURRENT_SKILL = "AS_SET_CURRENT_SKILL";
export const AS_ADD_SKILL = "AS_ADD_SKILL";
export const AS_UPDATE_SKILL = "AS_UPDATE_SKILL";
export const AS_REMOVE_SKILL = "AS_REMOVE_SKILL";
export const AS_SET_SEARCH_RESULTS = "AS_SET_SEARCH_RESULTS";

export const AS_RESET = "AS_RESET";
